module.exports = __webpack_public_path__ + "7d8f36380015c5b56cfae113fa746269.pdf";